export default function ConfigurationNav({ activeTab, onTabChange, siteId }) {
    const tabs = [
        {
            id: "door",
            label: "Door Configuration",
            shortLabel: "Door",
            icon: "fa-solid fa-door-open",
            desc: "ACS door, vibration & alert settings",
        },
        {
            id: "rms",
            label: "RMS Configuration",
            shortLabel: "RMS",
            icon: "fa-solid fa-tower-broadcast",
            desc: "Tenant-wise port & RMS parameters",
        },
    ];

    return (
        <div className="config-top-tabs mt-2">
            <div className="config-top-tabs__info">
                <span className="config-top-tabs__badge">
                    <i className="fa-solid fa-sliders" />
                    Site Configuration
                </span>
                {siteId ? (
                    <span className="config-top-tabs__site">
                        <i className="fa-solid fa-tower-cell me-1" />
                        {siteId}
                    </span>
                ) : null}
            </div>

            <div className="config-top-tabs__nav" role="tablist">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        type="button"
                        role="tab"
                        aria-selected={activeTab === tab.id}
                        className={`config-top-tabs__item ${activeTab === tab.id ? "active" : ""}`}
                        onClick={() => onTabChange(tab.id)}
                    >
                        <span className="config-top-tabs__icon">
                            <i className={tab.icon} />
                        </span>
                        <span className="config-top-tabs__text">
                            <span className="config-top-tabs__label">{tab.label}</span>
                            <span className="config-top-tabs__desc">{tab.desc}</span>
                        </span>
                    </button>
                ))}
            </div>
        </div>
    );
}
